import useSurveySettings from 'src/hooks/useSurveySettings';
import { useDashboardContext } from 'src/components/dashboard/DashboardContext';
import type { ComparisonMode } from 'src/components/followUp/hooks/useInitialFilterGroups';

/**
 * What a dashboard's comparison is against, decided once for the filter state and the sidebar alike.
 * The backend capability wins: a survey with a configured, enabled comparison survey compares against that
 * survey on every dashboard, whatever its filter rows say. Only without it does the dashboard's
 * `comparisonRangeFilter` row still enable the comparison against a previous period of the same survey.
 */
export const useComparisonMode = (): ComparisonMode | undefined => {
  const { yearOverYearComparisonAvailable } = useSurveySettings();
  const { filters } = useDashboardContext();

  if (yearOverYearComparisonAvailable) return 'comparisonSurvey';
  if (filters.comparisonRangeFilter) return 'previousPeriod';
  return undefined;
};

export default useComparisonMode;
